<template>
  <fieldset class="grid-4 bloco2 margem">
    <div>
      <label for="filtro-responsavel">Responsável</label>
      <select id="filtro-responsavel" :disabled="subordinados.length <= 1" v-model="usuarioTarefasLocal"
        v-if="subordinados.length > 0">
        <option v-if="subordinados.length > 1" :value="subordinados.map((user) => ({ valor: user.usuario_id }))">
          Todos</option>
        <option v-for="item in subordinados" :key="item.usuario_id" :value="[{ valor: item.usuario_id }]">{{ item.nome
        }}</option>
      </select>
      <div v-else class="loading">
        <div></div>
      </div>
    </div>
    <div>
      <label for="filtro-periodo-inicio">Período de</label>
      <input id="filtro-periodo-inicio" v-model="periodoInicioLocal" :disabled="buscarTarefasSemData == true"
        type="date">
    </div>
    <div>
      <label for="filtro-periodo-fim">Fim previsto até</label>
      <input id="filtro-periodo-fim" v-model="periodoFimLocal" :disabled="buscarTarefasSemData == true" type="date" />
    </div>
    <div style="align-content: end">
      <div class="tags" style="margin-top: 0.5rem">
        <a @click="$emit('toggleSemData')" :class="buscarTarefasSemData == true ? 'ativo' : ''" style="cursor: pointer"
          role="button" aria-pressed="false"> Tarefas sem fim previsto</a>
        <a :class="{ 'ativo': statusTarefas.map(i => i.valor).includes('Atrasado') }" @click="$emit('toggleAtrasadas')"
          style="cursor: pointer" role="button">Somente Atrasadas</a>
      </div>
    </div>
    <div>
      <label for="filtro-origem">Origem</label>
      <multiselect id="filtro-origem" v-model="origemLocal" :selectLabel="''" label="label" track-by="label"
        :hideSelected="true" :allowEmpty="false" :selectedLabel="''" :deselectLabel="''" :searchable="false"
        :multiple="true" :options="opcoesOrigem" :close-on-select="false">
      </multiselect>
    </div>
    <div>
      <label for="filtro-status-origem">Status da origem</label>
      <multiselect id="filtro-status-origem" v-model="statusOrigemLocal" :selectLabel="''" label="valor"
        track-by="valor" :hideSelected="true" :allowEmpty="false" :selectedLabel="''" :deselectLabel="''"
        :searchable="false" :multiple="true" :options="opcoesStatusOrigem" :close-on-select="false">
      </multiselect>
    </div>
    <div>
      <label for="filtro-status-tarefa">Status da tarefa</label>
      <multiselect id="filtro-status-tarefa" :selectLabel="''" label="label" track-by="valor" :hideSelected="true"
        :allowEmpty="false" :selectedLabel="''" :deselectLabel="''" :searchable="false" :multiple="true"
        v-model="statusTarefasLocal" :options="opcoesStatusTarefa" :close-on-select="false">
      </multiselect>
    </div>
    <div style="text-align: end; align-content: end" v-if="!loading">
      <i v-if="podeBaixarXml && !loadingXml" @click="$emit('baixarXml')" class="bi bi-file-earmark-arrow-down"
        style="font-size: 20px; margin-right: .5rem; cursor: pointer;" title="Baixar Relatório"
        aria-label="Baixar relatório">
      </i>
      <div v-if="loadingXml" class="loading">
        <div></div>
      </div>
      <button type="button" @click="$emit('buscar')">Buscar</button>
    </div>
  </fieldset>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'FiltrosTarefas',
  components: { Multiselect },
  props: {
    subordinados: { type: Array, default: () => [] },
    usuarioTarefas: { type: Array, default: null },
    periodoInicio: { type: String, default: '' },
    periodoFim: { type: String, default: '' },
    buscarTarefasSemData: { type: Boolean, default: false },
    statusTarefas: { type: Array, default: () => [] },
    origem: { type: Array, default: () => [] },
    statusOrigem: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    podeBaixarXml: { type: Boolean, default: false },
    loadingXml: { type: Boolean, default: false },
  },
  emits: ['update:usuarioTarefas', 'update:periodoInicio', 'update:periodoFim', 'update:origem', 'update:statusOrigem', 'update:statusTarefas', 'toggleSemData', 'definirPeriodo', 'toggleAtrasadas', 'buscar', 'baixarXml'],
  computed: {
    usuarioTarefasLocal: {
      get() { return this.usuarioTarefas; },
      set(v) { this.$emit('update:usuarioTarefas', v); },
    },
    periodoInicioLocal: {
      get() { return this.periodoInicio; },
      set(v) { this.$emit('update:periodoInicio', v); },
    },
    periodoFimLocal: {
      get() { return this.periodoFim; },
      set(v) { this.$emit('update:periodoFim', v); },
    },
    origemLocal: {
      get() { return this.origem; },
      set(v) { this.$emit('update:origem', v); },
    },
    statusOrigemLocal: {
      get() { return this.statusOrigem; },
      set(v) { this.$emit('update:statusOrigem', v); },
    },
    statusTarefasLocal: {
      get() { return this.statusTarefas; },
      set(v) { this.$emit('update:statusTarefas', v); },
    },
  },
  data() {
    return {
      opcoesOrigem: [
        { valor: 999, label: 'Projetos' },
        { valor: 1000, label: 'PAP Antigo' },
        { valor: 1, label: 'TNC' },
        { valor: 3, label: 'RAP' },
        { valor: 4, label: 'OS' },
        { valor: 5, label: 'Plano de Ação' },
        { valor: 6, label: 'Rotina' },
        { valor: 7, label: 'CRM' },
        { valor: 8, label: 'PAP Novo' },
        { valor: 1001, label: 'Reunião' },
      ],
      opcoesStatusOrigem: [
        { valor: 'Pendente' },
        { valor: 'Aprovado' },
        { valor: 'Em andamento' },
        { valor: 'Concluído' },
        { valor: 'Suspenso' },
      ],
      opcoesStatusTarefa: [
        { label: 'A iniciar', valor: 'Pendente' },
        { label: 'Em andamento', valor: 'Em andamento' },
        { label: 'Concluído', valor: 'Concluído' },
        { label: 'Cancelada', valor: 'Cancelada' },
      ],
    };
  },
};
</script>
